import { render, staticRenderFns } from "./StudyDesign.vue?vue&type=template&id=dbe64844"
import script from "./StudyDesign.vue?vue&type=script&lang=js"
export * from "./StudyDesign.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports